<script>
import { vote } from '../../api/polls';
import moment from 'moment';
import toHTML from 'linkifyjs/html';
import VClamp from 'vue-clamp';

import { SectionPostTypes } from '../../constants';

export default {
  name: 'CpSocialFeedPollPost',
  data() {
    return {
      showLikesModal: false,
      comments_count: this.poll.comments_count,
      optionVote: null,
      loading: false,
      voted: this.poll.voted,
      highestValue: 0,
      showAuthModal: false,
      isLoginCallbackActive: false,
      type: SectionPostTypes.POLLS,
    };
  },
  directives: {
    margin: require('../../directives/margins').margin,
    marginBottom: require('../../directives/margins').marginBottom,
    marginTop: require('../../directives/margins').marginTop,
    marginRight: require('../../directives/margins').marginRight,
    marginLeft: require('../../directives/margins').marginLeft,
  },
  components: {
    PersonIcon: require('../icons').default,
    CpBaseSvgIcon: require('../../base-svg-icon').default,
    CpButtonLink: require('../../button-link').default,
    CpImage: require('../../image').default,
    CpSocialShareDialog: require('../../dialogs/social-share').default,
    LikeActionButton: require('../actions/like-action-button').default,
    CpLikesProfiles: require('../../likes/likes-profiles').default,
    CpDialog: require('../../dialog').default,
    CommentActionButton: require('../actions/comment-action-button').default,
    CpCommentsPost: require('../../comments/box-comments').default,
    VClamp,
    CpGrid: require('../../grid').default,
    CpGridItem: require('../../grid-item').default,
    CpButton: require('../../button').default,
    CpBox: require('../../box').default,
    CpDialogAuthForm: require('../../auth-form/dialog-auth-form').default,
    CpCardHeaderReactions: require('../../components/CardHeaderReactions').default,
    CpShowInteractionsCount: require('../../components/ShowInteractionsCount').default,
  },
  props: {
    poll: { type: Object, default: () => {} },
    explore: Boolean,
    forShare: Boolean,
  },
  created() {
    const percentages = this.poll.options.map(opt => opt.percentage_votes);
    this.highestValue = this.highestSearcher(...percentages);
  },
  updated() {
    this.voted = this.poll.voted;
  },
  methods: {
    profile(slug) {
      return '/profile/' + slug;
    },
    handleLikesModal() {
      this.showLikesModal = !this.showLikesModal;
    },
    handleCountLikes(value) {
      value ? (this.poll.likes_count = this.poll.likes_count + 1) : (this.poll.likes_count = this.poll.likes_count - 1);
    },
    setCommentsCount(action) {
      action == 'remove' ? this.comments_count-- : this.comments_count++;
    },
    handleCloseButton() {
      this.showAuthModal = false;
      const isSocialLogin = window.sessionStorage.getItem('openWindowForSocialLogin');
      if (!this.isLoginCallbackActive && !isSocialLogin) {
        this.loading = false;
      }
    },
    loginCallbackAction() {
      this.isLoginCallbackActive = true;
      if (this.loading) {
        this.handleVote();
      }
      this.isLoginCallbackActive = false;
    },
    selectOption(option) {
      if (this.optionVote == option.id) {
        this.optionVote = null;
      } else {
        this.optionVote = option.id;
      }
    },
    submit() {
      this.loading = true;
      if (!this.authUser) {
        this.showAuthModal = true;
      } else {
        this.handleVote();
      }
    },
    handleVote() {
      vote(this.poll.id, { option_id: this.optionVote })
        .then(response => {
          this.poll.options = response.options;
          this.poll.votes_count = response.votes_count;
          this.poll.voted_option = this.optionVote;
          this.highestValue = this.highestSearcher(...this.poll.options.map(opt => opt.percentage_votes));
          this.voted = true;
          this.poll.voted = true;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.error = 'An error has occurred, try again!';
        });
    },
    highestSearcher(...percentages) {
      const percentArray = [...percentages];
      const highestValue = Math.max(...percentArray);
      return highestValue;
    },
  },
  computed: {
    authUser() {
      return this.$root.authUser;
    },
    formatEndDate() {
      const date = moment(this.poll.end_date);
      const diff = date.diff(moment());
      const endDays = Math.floor(moment.duration(diff).asDays());
      const endHours = moment.duration(diff).hours();
      return `${endDays} days, ${endHours} hours`;
    },
  },
};
</script>

<template>
  <div class="social-feed-post-wrapper">
    <!-- TO DO: uncomment this when we implement the new feed logic -->
    <!-- <div v-if="explore && poll.last_activity && !forShare" style="display: flex">
      <CpCardHeaderReactions :post="poll.last_activity" />
    </div>
    <hr v-if="explore && poll.last_activity && !forShare" class="search-results__tick_action" v-margin-top="0.25" /> -->

    <div class="profileContainer">
      <a :href="profile(poll.owner.slug)" v-margin-right="0.5">
        <cp-image :src="poll.owner.profile_image" circular :width="$root.isMobile ? '38' : '50'" :height="$root.isMobile ? '38' : '50'"></cp-image>
      </a>
      <p class="profileDescriptionContainer">
        <a :href="profile(poll.owner.slug)" class="buttons neutral6-color">{{ poll.owner.name }}</a>
        <span class="body neutral4-color" v-if="poll.type !== 'everyone'"
          >&nbsp;{{ poll.type === 'campaign' ? 'created a poll related to' : 'posted on' }} &nbsp;</span
        >
        <a
          v-if="poll.type !== 'everyone'"
          class="buttons primary-color"
          :href="poll.type === 'campaign' ? poll.crowdpac.slug : poll.type === 'group' ? poll.group.slug : '#'"
        >
          {{ poll.type === 'campaign' ? poll.crowdpac.name : poll.group.name }}
        </a>
      </p>
    </div>
    <a :href="poll.permalink" class="cursorPointer">
      <p class="subheadline1 neutral5-color">{{ poll.question }}</p>
    </a>
    <div>
      <h3 v-margin-bottom="0.4" class="buttons neutral5-color">Choose an option</h3>
      <span class="body neutral4-color">Your vote is confidential, only the creator can view it.</span>
    </div>
    <div v-margin-top="1" v-margin-left="2" v-margin-right="2">
      <cp-box
        outlined
        class="boxOptionsContainer"
        v-margin-bottom="0.3"
        :class="{ boxOptionsBackground: (voted || poll.status == 'finished') && poll.votes_count !== 0 && option.percentage_votes === highestValue }"
        v-for="option in poll.options"
        :key="option.option"
      >
        <p
          class="body neutral6-color"
          @click="!voted ? selectOption(option) : null"
          :class="{ disabledCursor: voted, cursorPointer: !voted && poll.status == 'active' }"
        >
          <i
            style="font-size: 15px"
            v-if="!voted && poll.status == 'active'"
            :class="{ 'far fa-dot-circle primary-color': optionVote === option.id, 'far fa-circle': optionVote !== option.id }"
          />{{ ' ' + option.option }}
          <i v-if="voted && poll.voted_option == option.id" class="far fa-check-circle primary-color" />
        </p>
        <p class="body primary-color" v-if="voted || poll.status == 'finished'">{{ option.percentage_votes }}%</p>
      </cp-box>
    </div>
    <div style="display: flex">
      <p class="footnote neutral5-color">{{ poll.votes_count }} {{ poll.votes_count == 1 ? 'vote' : 'votes' }}</p>
      <p v-if="poll.status == 'active'" class="footnote neutral5-color">&nbsp;- Voting ends in {{ formatEndDate }}</p>
      <p v-else class="footnote neutral5-color">&nbsp;- finished</p>
    </div>
    <div>
      <div v-if="!voted && poll.status == 'active'" :class="{ btnContainer: !$root.isPhone }">
        <cp-button @click="submit()" primary block :disabled="!optionVote || loading" :loading="loading"> Vote </cp-button>
      </div>
    </div>

    <div v-if="!forShare" style="margin-top: 10px !important">
      <CpShowInteractionsCount :type="type" :id="poll.id" :likesCount="poll.likes_count" :commentsCount="comments_count" :handleLikesModal="handleLikesModal" />
    </div>

    <cp-dialog v-if="showLikesModal && !forShare">
      <cp-likes-profiles :count-likes="poll.likes_count" :id="parseInt(poll.id)" :type="'polls'" @close="handleLikesModal"> </cp-likes-profiles>
    </cp-dialog>

    <div v-if="!forShare" class="social-feed-post-actions">
      <div class="post-action-button like">
        <like-action-button type="polls" :id="poll.id" :liked="poll.liked" :onSuccess="handleCountLikes" />
      </div>
      <div class="post-action-button comment">
        <comment-action-button :type="type" :id="poll.id" />
      </div>
      <div class="post-action-button share">
        <cp-social-share-dialog
          class="feed"
          :allow-share-feed="true"
          :type="'polls'"
          :post="poll"
          share-category="Poll"
          share-button-class="button--noborder"
          :url="poll.permalink"
          :explore="explore"
          title="Poll found via CrowdBlue - Social Network For Politics"
          :description="`Wanted to share this poll I found on CrowdBlue, the Social Network for Politics.`"
          :quote="poll.question"
          hashtags="crowdBlue,politics,political crowdfunding"
          twitter-user="crowdblue"
        ></cp-social-share-dialog>
      </div>
    </div>

    <cp-comments-post v-show="!forShare" :id="poll.id" :type="type" :setCount="setCommentsCount">
    </cp-comments-post>
    <cp-dialog-auth-form v-if="showAuthModal" :handleCloseButton="handleCloseButton" showSignUp :callback-action="loginCallbackAction" />
  </div>
</template>

<style scoped>
.disabledCursor {
  cursor: auto;
}
.selected {
  background-color: #ffe3da;
}
div.social-feed-post-profile-wrapper {
  display: flex;
  flex-direction: row;
  margin-bottom: 1em;
}
div.social-feed-post-profile-wrapper .details-wrapper {
  display: flex;
  flex-direction: column;
  padding-left: 10px;
}

div.social-feed-post-profile-wrapper .post-time {
  color: #666;
  text-decoration: none;
  font-size: 0.9em;
  font-weight: 400;
}

img.social-feed-post-img {
  max-width: 100%;
  max-height: 100%;
  min-width: 100%;
}
a.social-feed-post-link {
  display: block;
  padding-top: 10px;
  font-size: 1.1em;
}

div.social-feed-post-wrapper {
  width: 100%;
  padding: 1em;
  border-bottom: 2px solid var(--neutral3);
  margin-bottom: 2.5em;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: auto;
}
div.social-feed-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.social-feed-post-wrapper > * {
  width: 100%;
}

.mini-recipient__subtitle {
  margin-top: 0px;
}

div.social-feed-box-wrapper.mobile img.social-feed-post-img {
  min-height: 45vh;
  object-fit: cover;
}
div.social-feed-box-wrapper.mobile div.social-feed-post-wrapper {
  padding: 0.7em;
}
div.social-feed-post-img-placeholder {
  min-height: 400px;
  background: rgb(233, 94, 54);
  background: linear-gradient(180deg, rgba(233, 94, 54, 1) 65%, rgba(254, 130, 94, 1) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}
header.social-feed-title-header {
  text-align: center;
  margin: 30px 0px;
}
div.social-feed-post-description {
  padding-top: 10px;
}

.social-feed-sidebar {
  position: fixed;
}

.header-label {
  font-size: 16px;
  font-family: 'proxima-nova', Gotham, Helvetica, sans-serif;
  font-weight: 600;
  color: #121212;
}

.mobile-fixed-bottom-sidebar .social-feed-right-sidebar {
  padding: 15px;
  position: relative;
  max-width: 100% !important;
}

.small-desktop-right-sidebar .social-feed-right-sidebar {
  max-width: 12.2vh;
}

.small-desktop-right-sidebar .title-3 hr {
  display: none;
}

.search-results__tick_action {
  width: 50px;
  margin-right: auto;
}
.profileContainer {
  display: flex;
  align-items: center;
}
.boxOptionsContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
}
.boxOptionsBackground {
  background-color: var(--primary1);
  border-radius: 6px;
}
.btnContainer {
  width: 40%;
}
.cursorPointer {
  cursor: pointer;
}
.profileDescriptionContainer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
</style>
